type ContextNode = {
  id?: string | number;
  name?: string;
};

type ContextPathEntry = {
  CONTEXT?: ContextNode;
};

export const getOrderedContextPathNodes = (
  list: ContextPathEntry[] | undefined,
  currentId?: string | number,
): ContextNode[] => {
  const nodes = (list || [])
    .map((entry) => entry?.CONTEXT)
    .filter((node): node is ContextNode => Boolean(node));

  if (nodes.length < 2) {
    return nodes;
  }

  const normalizedCurrentId = String(currentId ?? "");
  const firstId = String(nodes[0]?.id ?? "");
  const lastId = String(nodes[nodes.length - 1]?.id ?? "");

  if (normalizedCurrentId && firstId === normalizedCurrentId && lastId !== normalizedCurrentId) {
    return [...nodes].reverse();
  }

  return nodes;
};

export const getDisplayContextPathNodes = (
  list: ContextPathEntry[] | undefined,
  currentId?: string | number,
  includeCurrent = true,
): ContextNode[] => {
  const orderedNodes = getOrderedContextPathNodes(list, currentId);

  if (includeCurrent) {
    return orderedNodes;
  }

  return orderedNodes.slice(0, -1);
};
